
//******************Exchange Rate Server Calls******************;

import {AddRefrenceDataActions} from './AddRefrenceDataConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export const AddRefrenceDataServer = {
  //  handleAddRefrenceData:handleAddRefrenceData,
  handleAddRefrenceData:handleAddRefrenceData,
  // getFieldsOfTable:getFieldsOfTable
};

//******************Insert AddRefrenceDatas******************;

function handleAddRefrenceData(data){
  
      const request=fetch(ROOT_URL+'/api/configurations/addRecordRefTable', {
          method: 'POST',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
            //  alert(JSON.stringify(response))
             if(response.status == "200"){
              toast.success(response.message)
            store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.SUCCESS,payload:data.data, message:response.message});
            return ;
            }else
            {
              store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED, error:response.error });
              return ;
              }    
           }).catch((error) => {
            store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED, error:failure_messages.unExpectedError});
             })
          }).catch((error) => {
           store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED, error:failure_messages.unExpectedError});
            })
      return {type:AddRefrenceDataActions.RefrenceData_Add.LOADING}

};
  
//******************Get AddRefrenceDatas******************;



//******************Update AddRefrenceData******************;

  
// function handleAddRefrenceData(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.AddRefrenceData.length>0)
//              store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.SUCCESS,payload:response.AddRefrenceData});
//              else
//              store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED});
//           })
//        return {type:AddRefrenceDataActions.RefrenceData_Add.LOADING}
 
//     };
  
// function updateAddRefrenceData(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:AddRefrenceDataActions.RefrenceData_Add.FAILED});
//     })
// return {type:AddRefrenceDataActions.RefrenceData_Add.LOADING}

// };
